import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('LineItemGroup');

const propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

function LineItemGroup({ className, children }) {
    return <ul className={bem(null, null, className)}>{children}</ul>;
}

LineItemGroup.propTypes = propTypes;

export default LineItemGroup;
